import { render, staticRenderFns } from "./day_practice.vue?vue&type=template&id=e20c0d1e&scoped=true"
import script from "./day_practice.vue?vue&type=script&lang=js"
export * from "./day_practice.vue?vue&type=script&lang=js"
import style0 from "./day_practice.vue?vue&type=style&index=0&id=e20c0d1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20c0d1e",
  null
  
)

export default component.exports